// NOTE: min-price / max-%change filtering now happens server-side (see
// /api/query `_filter_matches`), so the matches returned here are already the
// final, filtered set. Filtering client-side as well would make "Percent Move"
// (computed over this array) disagree with the server-computed "Forward Outcome"
// and fan chart again — so we only map here, never filter.
export function processQueryResponse(data: APIQueryResponse): { newQuery: StockChartQuery; newMatches: MatchesState[] } {
  const newQuery: StockChartQuery = {
    window: data.query.window,
    step: data.query.step,
    label: data.query.query_title,
    symbol: data.query.ticker,
    symbol_name: data.query.ticker_name,
    xaxis: data.query.query_dates,
    yaxis: data.query.query_data,
    forecast_window: data.query.forecast_window,
    beta: data.query.query_beta,
  };
  const newMatches = data.matches
    .map((match) => ({
      label: match.match_title,
      symbol: match.match_symbol,
      symbol_name: match.match_symbol_name,
      delisted: match.delisted,
      // New /api/query payloads provide the candidate table's display horizon.
      // Fall back to the source display horizon for older cached/rolling-deploy
      // payloads, where every result necessarily came from the source table.
      origin_window: match.origin_window ?? data.query.window * (data.query.step || 1),
      score: match.match_score,
      beta: match.match_beta,
      beta_delta: match.match_beta_delta,
      xaxis: match.match_dates,
      yaxis: match.match_data.map((value: number) => parseFloat(value.toFixed(2))),
      // Truncate ohlcv to match_dates length — match_ohlcv is extended to
      // curve_h_max rows for server-side forward-curve calculations but the
      // chart only needs window + forecast_window rows aligned with match_dates.
      ohlcv: match.match_ohlcv.slice(0, match.match_dates.length),
    }));
  return {newQuery, newMatches};
}
